import request from "../shared/http";
import appConfig from "../shared/js/app-config";

class ConversationService {

    async uploadMedia(file) {
        console.log("servicefile", file);
        const formData = new FormData();
        formData.append("files", file);
        formData.append("name", file.name);
        formData.append("type", file.type);
        formData.append("service_id", appConfig.getServiceId());
        console.log("formData", formData);
    
        try {
          const response = await request.post(
            `/upload-media/${appConfig.getServiceId()}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          console.log(`Media uploaded successfully:`, response);
          return response;
        } catch (error) {
          console.error(`Error uploading media:`, error);
          throw error;
        }
      }
    async getConversations({
        page=1,
        limit=10,
        searchKey = null,
    }) {
        const url = `/conversations/${appConfig.getServiceId()}`;
        const response = await request.get(url, {
            params: {
                page: page,
                limit: limit,
                search_key: searchKey,
            }
        });
        return response.data;
    }

    async getMessagesByConversation({
        page = null,
        limit=10,
        id,
        before,
    }) {
        const url = `/messages/${id}`;
        const response = await request.get(url, {
            params: {
                page: page,
                limit: limit,
                before: before,
            }
        });
        return response.data;
    }

    async sendMessage(model) {     
        if (model.message_type === 'media' && model.image) {
            console.log('image', model.image);
            const result = await this.uploadMedia(model.image);
            model.media_id = result.data[0].id;
            model.media_type = 'image';
            model.mime_type = result.data[0].fileType;
        }
        if (model.message_type === 'media' && model.audio) {
            console.log('audio', model.audio);
            const result = await this.uploadMedia(model.audio);
            model.media_id = result.data[0].id;
            model.media_type = 'audio';
            model.mime_type = result.data[0].fileType;
        }
        if (model.message_type === 'media' && model.record) {
            const result = await this.uploadMedia(model.record);
            model.media_id = result.data[0].id;
            model.media_type = 'audio';
            model.is_voice = true;
            model.mime_type = result.data[0].fileType;
        }
        const url = `/conversation/${appConfig.getServiceId()}`;
        const { data } = await request.post(url, {
            account_id: appConfig.getAccountId(),
            message: model.message,
            contact_id: model.contact_id,
            id: model.conversation_id,
            message_type: model.message_type,
            template_id: model.template_id,
            media_id: model.media_id,
            media_type: model.media_type,
            mime_type: model.mime_type,
            is_voice: model.is_voice || null,
            variables: model.variables,
            reply_id: null,
        });
        return data;
    }

    async sendReaction(emoji, wamid) {
        const url = `/conversation/react/${appConfig.getServiceId()}`;
        const { data } = await request.post(url, {
            emoji,
            wamid,
        });
        return data;
    }
}
export default new ConversationService();